import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, makeStyles, Box, Grid, Checkbox } from '@material-ui/core';
import { AddDocumentToBinderLogOptions, AddToDelegationLogOptions } from '../constants';
import React, { useState, useCallback, Fragment } from 'react';
import InputField from 'components/common/Study/InputField/index';
import { customStylesV2 } from 'components/common/Dropdown/DropDownListHelper';
import styles from '../styles.scss';
import lodash, { some } from 'lodash';
import moment from 'moment';
import { useEffect } from 'react';
import { Conditional } from 'common/components/layout/index';
import Select from 'react-select';
import DateTimePicker from 'common/components/DateTime/DateTimePicker';
import { getLocalDateNoTime } from 'common/util/dateTime';
import { STUDY_USER_TYPE } from 'components/common/Study/StudyTeamMemberForm/index';
import { delegationsUnderPITenurePredicate, isActivePI } from 'pages/delegationOfAuthority/util/predicates';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { getRawValue, getStringValue } from 'common/util/dataTypeValues';
import { dataSourceLogActions, dataSourceStatus } from 'pages/dataSource/utils/constants';
import AddUserToBinderContainer from 'part11/components/User/UserBulkActionList/AddUserToBinderModal/AddUserToBinderContainer';
import ChevronIcon from 'components/common/ChevronFaIcon/index';
import MultipleSelect from 'pages/delegationOfAuthority/v2/containers/DelegationSidePanel/DelegationDrawer/DelegationSection/MultiSelectWithCheckBox';
import DelegationStatement from 'pages/delegationOfAuthority/v2/components/DelegationStatement/DelegationStatement';
import { InputSection } from 'pages/delegationOfAuthority/v2/containers/DelegationSidePanel/CreateDelegationPanel';
import SelectDataSource from 'pages/delegationOfAuthority/v2/components/SelectDataSource/index';
import { delegationDisclaimers } from '../../../../delegationOfAuthority/v2/containers/DelegationSidePanel/DelegationDrawer/DelegationSection/constants';

/**
 * @typedef {object} DelegationLogProps
 * @property {*} [onAddToDelegationSelected]
 * @property {*} [staffDescriptorOptions]
 * @property {*} onSelected
 * @property {'now' | 'later'} defaultUserSelection
 * @property {*} selectedUser
 */

const DelegationLogStyles = makeStyles({
    width100: {
        width: '100%'
    },
    radioColorPrimary: {
        '&.Mui-checked': { color: '#2057AD' },
        paddingTop: 0,
        paddingBottom: 0,
    },
    legendFont: {
        marginTop: '10px',
        fontFamily: 'Hind',
        fontWeigth: 500,
        color: '#28282E',
        lineHeight: '20px',
        marginBottom: '5px',
    },
    delegationHeader: {
        marginTop: '10px',
        fontFamily: 'Hind',
        fontWeigth: 600,
        color: '#28282E',
    },
    my10: {
        margin: '10px 0 10px 0',
    },
    note: {
        display: 'flex',
        gap: '5px',
        padding: '10px',
        alignItems: 'center',
        borderRadius: '3px',
        border: '1px solid var(--blue-700, #C7DBFC)',
        background: '#F2F7FF',
        color: 'var(--grey- 500, #28282E)',
        fontFamily: 'Hind',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        marginTop: '10px'
    },
    typographyStyles: {
        fontFamily: 'Hind',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '0em',
        textAlign: 'left',
    },
});

const PI_ROLE = 'Principal Investigator';

/**
 * Display the delegation logs form, so the user can select
 * whether or not to add this new user to the delegation logs.
 *
 * @param {DelegationLogProps} props
 */
export function DelegationLog(props) {
    const classes = DelegationLogStyles();
    const [signatureList, setSignatureList] = useState([]);
    const [state, setState] = useState({
        userSelection: props.defaultUserSelection ? props.defaultUserSelection : AddToDelegationLogOptions.now,
        datasource: props.datasourceValue,
        bindersDatasource: AddDocumentToBinderLogOptions.now,
        role: props.role,
        startDate: undefined,
        endDate: undefined,
        responsibilities: [],
        signatureRequests: [],
        selectedUser: props.selectedUser
    });
    const [datasourceState, setDatasourceState] = useState(props.datasourceValue);
    const dataSourceValues = props.staffDescriptor;
    useEffect(() => {
        if (props.onSelected) {
            props.onSelected({ ...state, datasource: datasourceState });
        }
        if (state.userSelection === AddToDelegationLogOptions.later && state.bindersDatasource === AddUserToBinderContainer.later && state.selectedUser.access.value != STUDY_USER_TYPE.TEAM) {
            setState({
                ...state,
                datasource: undefined,
                role: undefined,
            });
        }
    }, [
        state.userSelection,
        state.role,
        state.startDate,
        state.endDate,
        state.responsibilities,
        state.signatureRequests,
        state.bindersDatasource,
        state.selectedUser,
        datasourceState
    ]);
    useEffect(() => {
        const signatureSuggestionEnabled = !(
            lodash.isNil(state.selectedUser) ||
            lodash.isNil(state.role) ||
            lodash.isEmpty(state.responsibilities)
        );
        signatureSuggestionEnabled ? suggestSignatures() : clearSuggestedSignatures();

        const existingDoAEnabled =
            !(lodash.isNil(state.selectedUser) ||
                lodash.isNil(state.role) ||
                lodash.isNil(state.startDate)) &&
            lodash.get(state.role, 'label') === PI_ROLE;

        existingDoAEnabled ? collectExistingDelegations() : clearExistingDelegations();
    }, [
        state.userSelection,
        state.datasource,
        state.role,
        state.startDate,
        state.responsibilities,
    ]);
    useEffect(() => {
        if (props.selectedUser.user && props.selectedUser.access) {
            let updateState = { ...state };
            updateState.selectedUser = { ...props.selectedUser };
            if (props.selectedUser.access.value === STUDY_USER_TYPE.TEAM) {
                updateState.userSelection = AddToDelegationLogOptions.now;
                updateState.bindersDatasource = AddDocumentToBinderLogOptions.now;
            }
            updateState.selectedUser = props.selectedUser;
            // updateState.datasource = props.datasourceValue;
            setDatasourceState(props.datasourceValue);
            setState({ ...updateState });
        }

    }, [props.selectedUser, props.datasourceValue]);

    const handleOnChange = (event) => {
        setState({ ...state, userSelection: event.target.value });
        if (props.onAddToDelegationSelected) {
            props.onAddToDelegationSelected(event.target.value);
        }
    };

    const handleBinderDocumentSelection = (event) => {
        setState({ ...state, bindersDatasource: event.target.value, role: null, signatureRequests: [], responsibilities: [] });
    };

    const parseDateFormat = (date) => {
        if (lodash.isNil(date)) {
            return null;
        }

        const dt = moment(date).format('LL');
        return moment.utc(dt);
    };


    const collectPISignatures = () => {
        if (lodash.get(state.role, 'label') === PI_ROLE) {
            return [
                {
                    label: <p><b style={{ fontWeight: 600 }}>{state.selectedUser.user.label}</b> (P.I)</p>,
                    value: `${state.selectedUser.user.value}::P.I.`,
                    data: { userId: state.selectedUser.user.value, role: 'P.I.', label: state.selectedUser.user.label },
                },
            ];
        }

        const { currentDOA } = props;

        return lodash
            .chain(currentDOA)
            .filter(
                ({ role, startDate, endDate }) =>
                    lodash.get(role, 'name') === PI_ROLE &&
                    isActivePI([startDate, endDate], parseDateFormat(moment()))
            )
            .map(({ user }) => ({
                label: <p><b style={{ fontWeight: 600 }}>{user.displayName}</b> (P.I)</p>,
                value: `${user.id}::P.I.`,
                data: {
                    role: 'P.I.',
                    userId: user.id,
                    label: user.displayName
                },
            }))
            .uniqBy('value')
            .value();
    };

    const collectStaffSignatures = () => {
        const { doaMode } = props;
        if (doaMode === 'CENTRAL' || lodash.get(state.role, 'label') === PI_ROLE) {
            return [];
        }
        return [
            {
                label: <p><b style={{ fontWeight: 600 }}>{state.selectedUser.user.label}</b> (Staff)</p>,
                value: `${state.selectedUser.user.value}::Staff`,
                data: { userId: state.selectedUser.user.value, role: 'Staff', label: state.selectedUser.user.label },
            },
        ];
    };


    const suggestSignatures = () => {
        const signatures = [];
        const piSignatureSuggested = collectPISignatures();
        const staffSignatureSuggested = collectStaffSignatures();

        signatures.push(...piSignatureSuggested);
        signatures.push(...staffSignatureSuggested);
        setSignatureList(signatures);
        setState({ ...state, signatureRequests: signatures });
    };

    const clearSuggestedSignatures = () => {
        setSignatureList([]);
        setState({ ...state, signatureRequests: [] });
    };

    const collectExistingDelegations = () => {
        const { currentDOA } = props;
        const staffDelegationsOverlappingWithNewPITenure = delegationsUnderPITenurePredicate(currentDOA, [
            state.startDate,
            state.endDate,
        ]);

        const delegationOptions = lodash.map(staffDelegationsOverlappingWithNewPITenure, (delegation) => ({
            id: lodash.get(delegation, 'id'),
            checked: true,
            label: lodash.get(delegation, 'user.displayName'),
            data: delegation,
        }));

        props.setDelegationRequiringNewPiSignature(delegationOptions);
    };

    const clearExistingDelegations = () => {
        props.setDelegationRequiringNewPiSignature([]);
    };

    const onToggleNewPiSignatureForExistingDelegation = (target) => {
        const targetDelegation = lodash.find(props.delegationRequiringNewPISignature, ({ id }) => target === id);
        targetDelegation.checked = !targetDelegation.checked;
        props.setDelegationRequiringNewPiSignature(lodash.cloneDeep(props.delegationRequiringNewPISignature));
    };
    // const determineValueForDataType = value => {
    //     const rawTypesNotAllowed = ['DATEONLY', 'DATETIME'];
    //     if (rawTypesNotAllowed.includes(props.dataType)) {
    //         return getStringValue(props.dataType, value);
    //     }
    //     return getRawValue(props.dataType, value);
    // };

    // const DataSourcesInput = React.memo(({
    //     dataSourceValues,
    //     props,
    //     datasourceState,
    //     setDatasourceState,
    //     determineValueForDataType
    // }) => {
    //     console.log("DataSourcesInput");
    //     const [dsError, setDserror] = useState({
    //         duplicatedDataSource: false,
    //     });

    //     const validateDuplicateValues = useCallback(
    //         (value) => {
    //             if (some(dataSourceValues, { value })) {
    //                 setDserror({
    //                     duplicatedDataSource: true,
    //                 });
    //                 return false;
    //             }
    //             return true;
    //         },
    //         [dataSourceValues]
    //     );

    //     const addNewDataSourceValue = useCallback(
    //         (addNewValue, callbackFn) => {
    //             if (!addNewValue.trim()) return;

    //             const value = determineValueForDataType(addNewValue);
    //             if (!validateDuplicateValues(value)) return;

    //             const dataSourceItem = {
    //                 value,
    //                 text: getStringValue(props.dataType, addNewValue),
    //                 status: dataSourceStatus.active.value,
    //                 order: dataSourceValues.length + 1,
    //                 dataType: props.dataType,
    //             };
    //             const newDataSourceValues = [...dataSourceValues, dataSourceItem];
    //             handleSaveDataSource(dataSourceLogActions.created, dataSourceItem, newDataSourceValues, callbackFn);
    //         },
    //         [dataSourceValues, props.dataType, validateDuplicateValues]
    //     );

    //     const handleSaveDataSource = useCallback(
    //         (action, dataSourceItem, dataSourceValues, callbackFn) => {
    //             const { id: dataSourceMetadataId, institutionId, name, description, type } = props.dataSource;
    //             const dataSourceLog = {
    //                 ...dataSourceItem,
    //                 value: String(dataSourceItem.value),
    //                 action,
    //                 dataSourceMetadataId,
    //                 institutionId,
    //                 name,
    //                 description,
    //                 type,
    //             };
    //             props.loadDataSourceLog(dataSourceLog);
    //             props.writeDataSourceValues(dataSourceValues);
    //             props.saveDataSource(institutionId);
    //             setDatasourceState({ value: dataSourceItem.value, label: dataSourceLog.text });
    //             props.onDataSourceSelected(dataSourceItem.value);
    //             callbackFn();
    //         },
    //         [props, setDatasourceState]
    //     );

    //     const memoizedSelectDataSource = useMemo(() => {
    //         return (
    //             <SelectDataSource
    //                 label="Data Source"
    //                 placeholder="Select Data Source"
    //                 dataSources={props.staffDescriptorOptions}
    //                 isRequired={true}
    //                 buttonLabel={'Add'}
    //                 handleSelectedDataSource={(value) => setDatasourceState({ value, label: value })}
    //                 handleCreateDataSource={addNewDataSourceValue}
    //                 canAddDataSource={props.canAddDataSource}
    //                 selectedDataSource={datasourceState && datasourceState.value}
    //                 dataSourceError={props.error.dataSource || dsError.duplicatedDataSource}
    //                 errors={dsError}
    //                 delegationDisclaimers={delegationDisclaimers}
    //             />
    //         );
    //     }, [
    //         props.staffDescriptorOptions,
    //         props.canAddDataSource,
    //         props.error.dataSource,
    //         dsError,
    //         datasourceState,
    //         addNewDataSourceValue,
    //     ]);

    //     return (
    //         <Fragment>
    //             {memoizedSelectDataSource}
    //             {props.error.dataSource && <label className={styles.errorText}>Datasource is required</label>}
    //         </Fragment>
    //     );
    // });

    const renderNewPISignatureForExistingDelegation = () => {
        const numberOfSelected = lodash.filter(props.delegationRequiringNewPISignature, ({ checked }) => checked).length;
        const singularOrPlural = numberOfSelected === 1 ? '' : 's';
        return (
            <Conditional condition={lodash.get(props.delegationRequiringNewPISignature, 'length') !== 0}>
                <section className={styles.NewPISignatureForExistingDelegation}>
                    <h5>Delegations that Require New P.I. Signature</h5>
                    <DelegationStatement type="warning" size="small">
                        <span>
                            Signature requests are automatically generated for any delegations that will be under the
                            tenure of the new PI. You can deselect delegations that don’t require a new P.I. signature.
                        </span>
                    </DelegationStatement>
                    <InputSection label={`${numberOfSelected} Delegation${singularOrPlural} Selected`}>
                        {lodash.map(props.delegationRequiringNewPISignature, ({ id, label, checked }) => (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disableRipple
                                        color="primary"
                                        checked={checked}
                                        onChange={() => onToggleNewPiSignatureForExistingDelegation(id)}
                                    />
                                }
                                label={label}
                            />
                        ))}
                    </InputSection>
                </section>
            </Conditional>
        );
    };


    return (
        <div>
            <Conditional condition={state.selectedUser.access.value == STUDY_USER_TYPE.TEAM || (props.isEditMode && props.selectedRow.delegation)}>
                <DataSourcesInput
                    dataSourceValues={dataSourceValues}
                    staffDescriptorOptions={props.staffDescriptorOptions}
                    dataSource={props.dataSource}
                    dataType={props.dataType}
                    datasourceState={datasourceState}
                    setDatasourceState={setDatasourceState}
                    loadDataSourceLog={props.loadDataSourceLog}
                    writeDataSourceValues={props.writeDataSourceValues}
                    saveDataSource={props.saveDataSource}
                    onDataSourceSelected={props.onDataSourceSelected}
                    canAddDataSource={props.canAddDataSource}
                    error={props.error}
                />

                <Conditional condition={!props.isEditMode}>
                    <div className={classes.note}>
                        <FontAwesomeIcon icon={faCircleInfo} />
                        <p>The Data Source helps us import your Team Member’s documents.</p>
                    </div>
                </Conditional>
            </Conditional>
            <Conditional condition={!props.isEditMode || (props.isEditMode && !props.selectedRow.delegation)}>
                <Conditional condition={state.selectedUser.access.value != STUDY_USER_TYPE.TEAM}>
                    <h2 className={classes.delegationHeader}>Delegation</h2>
                    <FormControl component="fieldset" className={[classes.my10, classes.width100]}>
                        <FormLabel component="legend" className={classes.legendFont} style={{ color: '#28282E' }}>Add this user to the Delegation Log?</FormLabel>
                        <RadioGroup
                            aria-label="user adding options"
                            name="addUsersOptions"
                            onChange={handleOnChange}
                            value={state.userSelection}
                        >
                            <FormControlLabel value={AddToDelegationLogOptions.now} control={
                                <Radio color="primary" className={classes.radioColorPrimary} required />
                            } label={<span className={classes.typographyStyles}>Yes</span>} />
                            <FormControlLabel value={AddToDelegationLogOptions.later} control={
                                <Radio color="primary" required className={classes.radioColorPrimary} />
                            } label={<span className={classes.typographyStyles}>No / Do this later</span>} />
                        </RadioGroup>
                    </FormControl>
                </Conditional>
                <Conditional condition={state.userSelection === AddToDelegationLogOptions.later && state.selectedUser.access.value != STUDY_USER_TYPE.TEAM}>
                    <FormControl component="fieldset" className={classes.my10}>
                        <FormLabel component="legend" className={classes.legendFont} style={{ color: '#28282E' }}>Add this user’s documents to this Study?</FormLabel>
                        <RadioGroup
                            aria-label="Users Document to binders options"
                            name="addDocumentToBinder"
                            onChange={handleBinderDocumentSelection}
                            value={state.bindersDatasource}
                        >
                            <FormControlLabel value={AddDocumentToBinderLogOptions.now} control={
                                <Radio color="primary" className={classes.radioColorPrimary} required />
                            } label={<span className={classes.typographyStyles}>Yes</span>} />
                            <FormControlLabel value={AddDocumentToBinderLogOptions.later} control={
                                <Radio color="primary" required className={classes.radioColorPrimary} />
                            } label={<span className={classes.typographyStyles}>No / Do this later</span>} />
                        </RadioGroup>
                    </FormControl>
                </Conditional>
                <Conditional condition={(state.userSelection === AddToDelegationLogOptions.later && state.selectedUser.access.value != STUDY_USER_TYPE.TEAM && state.bindersDatasource == AddDocumentToBinderLogOptions.now) || (state.userSelection === AddToDelegationLogOptions.now && state.selectedUser.access.value != STUDY_USER_TYPE.TEAM)}>
                    <DataSourcesInput
                        dataSourceValues={dataSourceValues}
                        staffDescriptorOptions={props.staffDescriptorOptions}
                        dataSource={props.dataSource}
                        dataType={props.dataType}
                        datasourceState={datasourceState}
                        setDatasourceState={setDatasourceState}
                        loadDataSourceLog={props.loadDataSourceLog}
                        writeDataSourceValues={props.writeDataSourceValues}
                        saveDataSource={props.saveDataSource}
                        onDataSourceSelected={props.onDataSourceSelected}
                        canAddDataSource={props.canAddDataSource}
                        error={props.error}
                    />
                </Conditional>
                <Conditional condition={state.userSelection === AddToDelegationLogOptions.now || state.selectedUser.access.value == STUDY_USER_TYPE.TEAM}>
                    <InputField
                        required={true}
                        label='Role'
                        htmlFor='studyRole'
                        customClasses={{
                            inputWrapper: styles.inputWrapper
                        }}
                    >
                        <Select
                            id='studyRole'
                            name='studyRole'
                            placeholder='Assign role'
                            options={props.studyRolesOptions}
                            data-cy="add-users-modals-study-role-select-list"
                            styles={customStylesV2}
                            value={state.role}
                            onChange={(value) => {
                                setState({ ...state, role: value });
                                props.setPISignationError(false);

                            }}
                            className={props.error.role && styles.errorInput}
                            components={{ DropdownIndicator: () => <ChevronIcon isOpen={Boolean(false)} customStyles={{ padding: '4px', paddingRight: '8px' }} /> }}

                        />
                        {props.error.role && <label className={styles.errorText}>Role is required</label>}
                        {props.PIsignatureError && <label className={styles.errorText} data-cy="add-users-modals-pi-signature-error">This PI can't be added since their tenure conflicts with an existing PI's tenure. If you want to add this PI, their tenure will need to be modified.</label>}
                        <Conditional condition={state.role && state.role.label == PI_ROLE}>
                            <div className={styles.piTip}>
                                <FontAwesomeIcon icon={faLightbulb} /> <b>Pro Tip</b>: If you wait to add your Principal Investigator until the end of your Delegation Log setup, all of their signature requests will go out at the same time.
                            </div>
                        </Conditional>
                    </InputField>
                    <Box className={styles.DateInputWrapper} component='div' >
                        <Grid container spacing={3}>
                            <Grid item xs>
                                <InputField
                                    label='Start Date'
                                    htmlFor='startDate'
                                    required={false}
                                    customClasses={{
                                        inputWrapper: styles.inputWrapper
                                    }}
                                >
                                    <DateTimePicker
                                        className={styles.DatePicker}
                                        autoFocus={false}
                                        time={false}
                                        noTimezone={true}
                                        id='startDate'
                                        name='startDate'
                                        value={state.startDate}
                                        onChange={(value) => setState({ ...state, startDate: value && getLocalDateNoTime(value).toISOString() })}
                                        max={new Date(2099, 11, 31)}
                                    />
                                </InputField>
                            </Grid>
                            <Grid item xs>
                                <InputField
                                    label='End Date'
                                    htmlFor='endDate'
                                    required={false}
                                    customClasses={{
                                        inputWrapper: styles.inputWrapper
                                    }}
                                >
                                    <DateTimePicker
                                        className={styles.DatePicker}
                                        autoFocus={false}
                                        time={false}
                                        noTimezone={true}
                                        id='endDate'
                                        name='endDate'
                                        value={state.endDate}
                                        onChange={(value) => setState({ ...state, endDate: value && getLocalDateNoTime(value).toISOString() })}
                                        max={new Date(2099, 11, 31)}
                                        min={new Date(state.startDate)}
                                    />
                                </InputField>
                            </Grid>
                        </Grid>
                    </Box>
                    <InputField
                        // label='Responsibilities'
                        htmlFor='responsibilities'
                        customClasses={{
                            inputWrapper: styles.padding0
                        }}

                    >
                        {/* <MultiSelect
                            id='responsibilities'
                            name='responsibilities'
                            placeholder='Select responsibilities'
                            options={props.responsibilitiesOptions}
                            onSelectedOption={(e) => setState({ ...state, responsibilities: e })}
                        /> */}
                        <MultipleSelect
                            handleChange={(e) => setState({ ...state, responsibilities: e })}
                            id='responsibilities'
                            options={props.responsibilitiesOptions}
                            selectedValues={state.responsibilities}
                            label='Responsibilities'
                            placeHolder='Select Responsibilities'
                            canSelectAll={true}
                        />

                    </InputField>

                    {
                        (signatureList.length > 0) && (
                            <InputField
                                required={false}
                                htmlFor='signatureRequests'
                                customClasses={{
                                    inputWrapper: styles.padding0
                                }}
                            >
                                <MultipleSelect
                                    handleChange={(e) => setState({ ...state, signatureRequests: e })}
                                    id='signatureRequests'
                                    options={signatureList}
                                    selectedValues={state.signatureRequests}
                                    label='Signature Requests'
                                    placeHolder='Select Staff for Signatures'
                                    canSelectAll={true}
                                />

                            </InputField>
                        )
                    }
                    {renderNewPISignatureForExistingDelegation()}
                </Conditional>
            </Conditional>

        </div>
    );
}

const DataSourcesInput = React.memo(({
    dataSourceValues,
    staffDescriptorOptions,
    dataSource,
    dataType,
    datasourceState,
    setDatasourceState,
    loadDataSourceLog,
    writeDataSourceValues,
    saveDataSource,
    onDataSourceSelected,
    canAddDataSource,
    error
}) => {
    const [dsError, setDserror] = useState({
        duplicatedDataSource: false,
    });

    const validateDuplicateValues = useCallback((value) => {
        if (some(dataSourceValues, { value })) {
            setDserror({ duplicatedDataSource: true });
            return false;
        }
        return true;
    }, [dataSourceValues]);

    const getRawVal = useCallback((value) => {
        const rawTypesNotAllowed = ['DATEONLY', 'DATETIME'];
        return rawTypesNotAllowed.includes(dataType)
            ? getStringValue(dataType, value)
            : getRawValue(dataType, value);
    }, [dataType]);

    const addNewDataSourceValue = useCallback((addNewValue, callbackFn) => {
        if (!addNewValue.trim()) return;
        const value = getRawVal(addNewValue);
        if (!validateDuplicateValues(value)) return;

        const dataSourceItem = {
            value,
            text: getStringValue(dataType, addNewValue),
            status: dataSourceStatus.active.value,
            order: dataSourceValues.length + 1,
            dataType,
        };
        const newDataSourceValues = [...dataSourceValues, dataSourceItem];
        handleSaveDataSource(dataSourceLogActions.created, dataSourceItem, newDataSourceValues, callbackFn);
    }, [dataSourceValues, dataType, getRawVal, validateDuplicateValues]);

    const handleSaveDataSource = useCallback((action, dataSourceItem, allValues, callbackFn) => {
        const log = {
            ...dataSourceItem,
            value: String(dataSourceItem.value),
            action,
            dataSourceMetadataId: dataSource.id,
            institutionId: dataSource.institutionId,
            name: dataSource.name,
            description: dataSource.description,
            type: dataSource.type,
        };
        loadDataSourceLog(log);
        writeDataSourceValues(allValues);
        saveDataSource(dataSource.institutionId);
        setDatasourceState({ value: dataSourceItem.value, label: log.text });
        onDataSourceSelected(dataSourceItem.value);
        callbackFn();
    }, [dataSource, loadDataSourceLog, writeDataSourceValues, saveDataSource, onDataSourceSelected, setDatasourceState]);

    return (
        <Fragment>
            <SelectDataSource
                label="Data Source"
                placeholder="Select Data Source"
                dataSources={staffDescriptorOptions}
                isRequired={true}
                buttonLabel="Add"
                handleSelectedDataSource={(value) => setDatasourceState({ value, label: value })}
                handleCreateDataSource={addNewDataSourceValue}
                canAddDataSource={canAddDataSource}
                selectedDataSource={datasourceState && datasourceState.value}
                dataSourceError={error.dataSource || dsError.duplicatedDataSource}
                errors={dsError}
                delegationDisclaimers={delegationDisclaimers}
            />
            {error.dataSource && <label className={styles.errorText}>Datasource is required</label>}
        </Fragment>
    );
});

